import React from 'react';
import Grid from '@mui/material/Grid';
import { InspectionContents } from '../../css/CSS.js';
import ReportlistBody from './ReportlistBody.js';

export default function ReportlistFrame() {
    return (
        <InspectionContents sx={{ pb: 2, pt: 2, }} maxWidth="xl">
            < Grid sx={{ height: 64 }} />
            <Grid container columns={12} spacing={0} sx={{ pt: 2 }} maxWidth="xl" >
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ReportlistBody />
                </Grid>
            </Grid>
        </InspectionContents>
    );
}